import { Navigate, Outlet } from "react-router-dom";

import { useWizardFlow } from "@/hooks/useWizardFlow";

export function WizardRouteGuard() {
  const { blockedRedirect } = useWizardFlow();

  if (blockedRedirect) {
    return <Navigate to={blockedRedirect} replace />;
  }

  return <Outlet />;
}
